import React, { Component } from 'react'
import axios from 'axios'


const token = localStorage.getItem("token");

class UploadGalleryImage extends Component {
	constructor(props) {
		super(props)
     
	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
      
        const formData = new FormData();
        const imagefile = document.querySelector('#imagefile');
        formData.append("image", imagefile.files[0]);
		console.log(this.state)
		axios
			.post(`https://shoppee-clone.herokuapp.com/gallery`, formData,{
                headers: { 'Content-Type': 'multipart/form-data' }
              })
			.then(response => {
				  // ALERT
                  console.log(response)
                  window.location.replace("/gallery");
			})
			.catch(error => {
        alert("error")
				console.log(error)
			})
	}
 
	render() {
		if (token != null) {
			return (
				<div>
			
			<div className="d-flex flex-column w-100 w-md-75 justify-content-center h-100">
			  <div className="custom-file">
				<form onSubmit={this.submitHandler} encType="multipart/form-data">
					<label className="custom-file-label d-flex justify-content-around"  htmlFor="customFile"><h3><i class="bi bi-emoji-smile"></i>&nbsp;Flex your keyboard here&nbsp;<i class="bi bi-emoji-smile"></i></h3></label>
					<input type="file" className="custom-file-input" id="imagefile" />
				  <div className="w-100 col-50 mt-4 d-flex justify-content-around">
					<button type="submit" className="px-sm-5 px-3 py-2 btn btn-dark">Submit</button>
				  </div>
				</form></div></div></div>
		  
			  
			)
		}
		
	}
}

export default UploadGalleryImage;